import { render, staticRenderFns } from "./ContentBlockVideo.vue?vue&type=template&id=6486dfd8&"
import script from "./ContentBlockVideo.vue?vue&type=script&lang=js&"
export * from "./ContentBlockVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports